import { useEffect, useState } from "react";
import "./Header.css"
import { List, Search, CaretDownFill, Gear } from 'react-bootstrap-icons';
import { useSelector } from "react-redux";
import {Link} from "react-router-dom"

const Header = ({minimizer, minimized}) => {
    return(
      <header className="header">
        <div className="container">
          <Link to="/" className="logo"><img src="/static/icons/logo.png" alt="logo" style={{height: "44px"}}/></Link>
          <nav className="nav">
            <Link to="/">Home</Link>
            <Link to="/products">Products</Link>
            <Link to="/contact">Contact</Link>
            <Link to="/privacy-policy">Privacy Policy</Link>
          </nav>
          <div className="auth-buttons">
            <a href="https://extension.wspoints.com" target="_blank" ><button className="login-btn">Login</button></a>
            <Link to="/sign-up"><button className="signup-btn">Sign Up</button></Link>
          </div>
        </div>
      </header>
    )
}

export default Header